"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var import_platform = require("@hcengineering/platform");
var import_lang = require("./lang");
var import_global_profile = __toESM(require("@hcengineering/global-profile"));
(0, import_platform.addStringsLoader)(import_global_profile.globalProfileId, import_lang.loadLang);
const icons = require("../assets/icons.svg");
const ProfileBackground = require("../assets/hero-dark.png");
const ProfileBackgroundLight = require("../assets/hero-light.jpg");
(0, import_platform.loadMetadata)(import_global_profile.default.icon, {
  Globe: `${icons}#globe`
});
(0, import_platform.loadMetadata)(import_global_profile.default.image, {
  ProfileBackground,
  ProfileBackgroundLight
});
//# sourceMappingURL=index.js.map
